require('./ctxToolbarButton.style.scss');
class ctxToolbarButtonController {
    constructor($scope, $attrs) {
        this.icon = $attrs.icon;
        this.id = $attrs.eventId;
        this.noPermissionsText='Insufficient permissions.'

        if(angular.isUndefined($attrs.visible)) {
            this.visible = true;
        }
    }

    clicked() {
        if(!this.disabled) {
            this.action();
        }
    }
}

ctxToolbarButtonController.$inject = ['$scope', '$attrs'];

const ctxToolbarButtonComponent = {
    controller: ctxToolbarButtonController,
    template: require('./ctxToolbarButton.template.html'),
    scope: {},
    bindings : {
        action: '&',
        disabled: '<?',
        visible: '<?',
        text: '@',
        tooltip: '@',
        permissions:'<?'
    }
};

module.exports = ctxToolbarButtonComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxToolbarButton/ctxToolbarButton.component.js